import { reducer as identityReducer } from '@/store/Identity'
import { reducer as localizeReducer } from '@/store/Localize'
import { reducer as permissionsReducer } from '@/store/Permissions'
import { reducer as menuReducer } from '@/store/Menu'
import { reducer as helpReducer } from '@/store/Help'
import { reducer as reportDesigner } from '@/components/reportDesigner/reducer'
import { reducer as backgroundJobs } from '@/store/backgroundJobs'
import { reducer as blockUiReducer } from '@/store/BlockUI'
import { reducer as notificationReducer } from '@/store/Notifications'
import { reducer as fileServiceReducer } from '@/store/FileService'
import { reducer as documentationReducer } from '@/store/Documentation'
import { reducer as codeListsReducer } from '@/store/CodeLists'
import { reducer as resourceReducer } from '@/store/Resources'
import { reducer as myTasksReducer } from '@/store/myTasks'
import { reducer as myActiveTaskReducer } from '@/store/myActiveTask'
import { reducer as institutionGroupsReducer } from '@/store/InstitutionGroups'
import { reducer as formsReducer } from '@/store/Forms'
import { reducer as cacheReducer } from '@/store/Cache'
import { reducer as myTicketsReducer } from '@/store/MyTickets'
import { reducer as organizationalUnitsReducer } from '@/store/OrganizationalUnits'
import { reducer as dialogsReducer } from '@/store/Dialogs'
import { reducer as jobPositionReducer } from '@/store/JobPosition'
import { reducer as ticketCommentsReducer } from '@/store/TicketComments'
import { reducer as messagesReducer } from '@/store/Messages'
import { reducer as reportingGroupsReducer } from '@/store/ReportingGroups'
import { reducer as usersManagementReducer } from '@/store/usersManagement'
import { reducer as reportingCyclesReducer } from '@/store/reportingCycles'
import { reducer as reportingYearReducer } from '@/store/ReportingYear'
import { reducer as submittedReportReducer } from '@/store/SubmittedReport'
import { reducer as reportTemplateReducer } from '@/store/ReportTemplate'
import { reducer as reportSubmitterReducer } from '@/store/ReportSubmitters'
import { reducer as reportingCycleCollisionsReducer } from '@/store/ReportingCycleCollisions'
import { reducer as reportSubmissionGroupReducer } from '@/store/ReportSubmissionGroup'
import { reducer as reportSubmissionsReducer } from '@/store/ReportSubmissions'
import { reducer as reportSubmissionGroupCommentsReducer } from '@/store/ReportSubmissionGroupComments'
import { reducer as reportSubmissionCommentsReducer } from '@/store/ReportSubmissionComments'
import { reducer as outputReportGroupReducer } from '@/store/OutputReportGroup'
import { reducer as outputReportsReducer } from '@/store/OutputReports'
import { reducer as institutionReportGroupReducer } from '@/store/InstitutionReportGroup'
import { reducer as institutionReportsReducer } from '@/store/InstitutionReports'
import { reducer as passwordReducer } from '@/store/Password'
import { reducer as rsaKeysReducer } from '@/store/RsaKeys'
import { reducer as personalAccessTokensReducer } from '@/store/PersonalAccessTokens'
import { reducer as dataCrossingsReducer } from '@/store/dataCrossing'
import { reducer as documentationViewerReducer } from '@/store/DocumentationViewer'
import { reducer as temporaryFilesReducer } from '@/store/TemporaryFileAttachment'
import { reducer as dashboardReducer } from '@/store/Dashboard'
import { reducer as announcementsReducer } from '@/store/announcements'
import { reducer as announcementsRecipientsReducer } from '@/store/AnnouncementsRecipients'
import { reducer as jobPositionPermissionsReducer } from '@/store/JobPositionPermissions'
import { reducer as reportTemplateFileReducer } from '@/store/ReportTemplateFile'
import { reducer as inChargeOfInstitutionsReducer } from '@/store/InChargeOfInstitutions'
import { reducer as reportTemplateSelectorReducer } from '@/store/ReportTemplateSelector'
import { reducer as reportGroupCycleParameterReducer } from '@/store/ReportGroupCycleParameters'
import { reducer as cbsReportsReducer } from '@/store/cbsReports'
import { reducer as notificationConfigurations } from '@/store/notificationConfigurations'
import { reducer as phoneNumberReducer } from '@/store/phoneNumber'
import { reducer as twoFactorAuthReducer } from '@/store/twoFactorAuth'
import { reducer as languageSettingsReducer } from '@/store/languageSettings'
import { reducer as outputReportGroupDefinitionsReducer } from '@/store/outputReportGroupDefinitions'
import { reducer as systemRsaKeysReducer } from '@/store/systemRsaKeys'
import { reducer as settingsReducer } from '@/store/settings'
import { reducer as userLegacyCodeReducer } from '@/store/userLegacyCode'
import { reducer as checkingRulesReducer } from '@/store/checkingRules'
import { reducer as reportTemplateCategoryReducer } from '@/store/reportTemplateCategory'
import { reducer as workflowDefinitionReducer } from '@/store/workflowDefinition'
import { reducer as workflowDefinitionVersionReducer } from '@/store/workflowDefinitionVersion'

export default {
  dialogs: dialogsReducer,
  cache: cacheReducer,
  forms: formsReducer,
  identity: identityReducer,
  localization: localizeReducer,
  permissions: permissionsReducer,
  menu: menuReducer,
  help: helpReducer,
  reportDesigner,
  backgroundJobs,
  blockUI: blockUiReducer,
  notifications: notificationReducer,
  fileService: fileServiceReducer,
  codeLists: codeListsReducer,
  documentation: documentationReducer,
  resources: resourceReducer,
  myTasks: myTasksReducer,
  myActiveTask: myActiveTaskReducer,
  myTickets: myTicketsReducer,
  organizationalUnits: organizationalUnitsReducer,
  jobPosition: jobPositionReducer,
  messages: messagesReducer,
  ticketComments: ticketCommentsReducer,
  reportingGroups: reportingGroupsReducer,
  usersManagement: usersManagementReducer,
  reportingCycles: reportingCyclesReducer,
  reportingYear: reportingYearReducer,
  institutionGroups: institutionGroupsReducer,
  submittedReport: submittedReportReducer,
  reportSubmitters: reportSubmitterReducer,
  reportSubmissionGroup: reportSubmissionGroupReducer,
  reportSubmissions: reportSubmissionsReducer,
  reportSubmissionGroupComments: reportSubmissionGroupCommentsReducer,
  reportSubmissionComments: reportSubmissionCommentsReducer,
  outputReportGroup: outputReportGroupReducer,
  outputReports: outputReportsReducer,
  institutionReportGroup: institutionReportGroupReducer,
  institutionReports: institutionReportsReducer,
  reportingCycleCollisions: reportingCycleCollisionsReducer,
  reportTemplate: reportTemplateReducer,
  password: passwordReducer,
  rsaKeys: rsaKeysReducer,
  personalAccessTokens: personalAccessTokensReducer,
  dataCrossing: dataCrossingsReducer,
  documentationViewer: documentationViewerReducer,
  dashboard: dashboardReducer,
  announcements: announcementsReducer,
  announcementsRecipients: announcementsRecipientsReducer,
  reportTemplateFile: reportTemplateFileReducer,
  jobPositionPermissions: jobPositionPermissionsReducer,
  inChargeOfInstitutions: inChargeOfInstitutionsReducer,
  reportTemplateSelector: reportTemplateSelectorReducer,
  reportGroupCycleParameter: reportGroupCycleParameterReducer,
  cbsReports: cbsReportsReducer,
  notificationConfigurations: notificationConfigurations,
  phoneNumber: phoneNumberReducer,
  twoFactorAuth: twoFactorAuthReducer,
  languageSettings: languageSettingsReducer,
  outputReportGroupDefinitions: outputReportGroupDefinitionsReducer,
  systemRsaKeys: systemRsaKeysReducer,
  settings: settingsReducer,
  userLegacyCode: userLegacyCodeReducer,
  checkingRules: checkingRulesReducer,
  reportTemplateCategory: reportTemplateCategoryReducer,
  workflowDefinition: workflowDefinitionReducer,
  workflowDefinitionVersion: workflowDefinitionVersionReducer,

  temporaryFiles: temporaryFilesReducer
}



// WEBPACK FOOTER //
// ./src/internal-app/reducers.js